import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  DefaultLeftWrapper,
} from "scmp-app/components/header/styles";

export const getDefaultLayout = ({
  config,
  features,
  initEdition,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <AbsoluteCenterFeatureContainer>
      {features.logoTextLink({
        showIn: "mobileUp",
      })}
    </AbsoluteCenterFeatureContainer>
  ),
  left: (
    <DefaultLeftWrapper>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      {features.search({ showIn: "mobileUp" })}
      {features.oneLineMenu({
        appBarVariant: config?.appBarVariant,
        initEdition,
        isShowFullList: false,
        isShowPrefixHyphen: false,
        showIn: "desktopUp",
      })}
    </DefaultLeftWrapper>
  ),
  right: (
    <>
      {features.subscription({
        showIn: "tabletUp",
      })}
      {features.dashboard({ showIn: "mobileUp" })}
    </>
  ),
});
